import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 256 256"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#b5b5b5",
  "stroke-miterlimit": "10",
  d: "M25 4C12.316 4 2 12.973 2 24c0 6.188 3.336 12.066 8.95 15.84-.134 1.05-.665 3.601-2.766 6.586l-1.106 1.566L9.055 48c5.43 0 9.101-3.328 10.308-4.605C21.195 43.797 23.09 44 25 44c12.684 0 23-8.973 23-20S37.684 4 25 4z",
  "font-family": "none",
  "font-size": "none",
  "font-weight": "none",
  style: {"mix-blend-mode":"normal"},
  "text-anchor": "none",
  transform: "scale(5.12)"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }